import React from 'react';
import FeatureCards from "../../components/FeatureCards/FeatureCards";
import CTA from "../../components/Constant/cta/CTA";
import TimelineSection from "../../components/TimelineSection/TimelineSection";
import WhySection from "../../components/WhySection/WhySection";
import LocationTimeline from "../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../components/IntroSection/IntroSection";
import FAQList from "../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../components/ServiceCards/ServiceCards ";

export default function ItalyJurisdiction() {

    return (
        <main className='main'>
            <IntroSection
                title="Company Formation, Residency & Investment in Italy"
                subtitle="Business Opportunities, Residency & Tax Optimization"
                description="Italy offers a unique blend of business opportunities, lifestyle advantages, and tax incentives for foreign investors. With its Non-Dom flat tax regime (€100k on worldwide income), investment-based residency, and strong EU market access, Italy is becoming an attractive jurisdiction for HNWIs, entrepreneurs, and global families."
                badges={[
                    "EU Residency",
                    "Company Formation",
                    "€100k Non-Dom Regime"
                ]}
                buttonText="Request an Italy Jurisdiction Proposal →"
                buttonLink="/quote"
                imageSrc={require('../../assets/images/jurisdictions/italy-ju.jpg')}
                imageAlt="Italy Company Formation, Residency & Investment"
            />


            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Choose Italy?'
                        blocks={[
                            {
                                items: [
                                    {
                                        title: "Non-Dom Tax Regime",
                                        text: "€100,000 flat tax on global income."
                                    },
                                    {
                                        title: "Investor Visa",
                                        text: "Residency through investments starting from €250,000."
                                    },
                                    {
                                        title: "EU Market Access",
                                        text: "Full European Union membership."
                                    },
                                    {
                                        title: "Double Tax Treaties",
                                        text: "Over 100 treaties worldwide."
                                    },
                                    {
                                        title: "Lifestyle Benefits",
                                        text: "Culture, healthcare, education, and Mediterranean lifestyle."
                                    },
                                    {
                                        title: "Strategic Business Location",
                                        text: "Central EU hub with global logistics connectivity."
                                    }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Company Formation in Italy"
                        blocks={[
                            {
                                title: "Types of Companies",
                                items: [
                                    { text: "Società a Responsabilità Limitata (S.r.l.) – private limited company, most common." },
                                    { text: "Società per Azioni (S.p.A.) – public limited company, suitable for larger businesses." },
                                    { text: "Branch of Foreign Company – expand international firms." },
                                    { text: "Partnerships (S.n.c., S.a.s.) – smaller enterprises." }
                                ]
                            },
                            {
                                title: "Key Features",
                                items: [
                                    { text: "Minimum capital: €10,000 for S.r.l. (can be lower for simplified version)." },
                                    { text: "Corporate tax: ~24% + regional tax (3–4%)." },
                                    { text: "VAT registration required for most activities." },
                                    { text: "Strong labor and compliance requirements compared to offshore jurisdictions." }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Residency & Immigration in Italy"
                        subtitle='Investor Visa for Italy'
                        blocks={[
                            {
                                title: "Investment Residency Options",
                                items: [
                                    { text: "€250,000 investment in an innovative startup." },
                                    { text: "€500,000 in an Italian company." },
                                    { text: "€2,000,000 in Italian government bonds." },
                                    { text: "€1,000,000 philanthropic donation." }
                                ]
                            },
                            {
                                title: "Benefits",
                                items: [
                                    { text: "2-year renewable residency permit." },
                                    { text: "Family members included." },
                                    { text: "Path to long-term EU residency & citizenship." }
                                ]
                            },
                            {
                                title: "Elective Residency Visa",
                                items: [
                                    { text: "For retirees or individuals with passive income." },
                                    { text: "Requires proof of stable income from abroad." }
                                ]
                            },
                            {
                                title: "Citizenship",
                                items: [
                                    { text: "Available after 10 years of residence." }
                                ]
                            }
                        ]}
                    />

                    <ServiceCards
                        title='Italy Non-Dom Tax Regime'
                        services={[
                            {
                                title: "Flat Tax",
                                text: "€100,000 annual tax on worldwide income."
                            },
                            {
                                title: "Duration",
                                text: "Valid for up to 15 years."
                            },
                            {
                                title: "Family Members",
                                text: "Can join for €25,000 each."
                            },
                            {
                                title: "Attractive for HNWIs",
                                text: "Ideal for high-net-worth individuals and global entrepreneurs."
                            },
                            {
                                title: "No Inheritance Tax",
                                text: "On foreign assets."
                            }
                        ]}
                    />

                    <FeatureCards
                        title='Advantages of Italy Jurisdiction'
                        features={[
                            {
                                title: "EU Residency & Citizenship Path",
                                text: "Access to EU benefits and citizenship eligibility."
                            },
                            {
                                title: "Non-Dom Tax Regime",
                                text: "Optimized taxation for global income."
                            },
                            {
                                title: "Company Structures for EU Business",
                                text: "SL, SA, branches, and partnerships available."
                            },
                            {
                                title: "Investor Visa Options",
                                text: "Multiple routes for residency and investment."
                            },
                            {
                                title: "Lifestyle Benefits",
                                text: "Culture, healthcare, education, and Mediterranean living."
                            }
                        ]}
                    />


                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <CTA
                        title="Looking to relocate or invest in Italy?"
                        description="Offshore Advisory helps with company formation, Investor Visa residency, and non-dom tax planning."
                        buttonText="Book an Italy Consultation Today →"
                        buttonLink="/quote"
                    />

                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "How much must I invest for Italian residency?",
        answer: "Starting from €250,000 in an innovative startup."
    },
    {
        question: "What is the Italy Non-Dom tax?",
        answer: "Flat €100k per year on global income."
    },
    {
        question: "How long does it take to incorporate a company?",
        answer: "Usually 2–4 weeks."
    },
    {
        question: "Can I buy property for residency?",
        answer: "Property alone does not qualify, but it strengthens residency applications (Elective or Investor Visa)."
    },
    {
        question: "How long to citizenship?",
        answer: "10 years of legal residence."
    }
];
